export default function getCaretPosition({
  caretTrapIndexes = [],
  currCaretPos = 0,
  formattedValue = '',
  lastFormattedValue = '',
  placeholder = '',
  placeholderChar = '_',
  value = '',
}) {
  const strValue = typeof value === 'number' ? value.toString() : value;
  let startingSearchIndex = 0;

  if (currCaretPos === 0 || !strValue.length) {
    return startingSearchIndex;
  }

  const editLength = strValue.length - lastFormattedValue.length;
  const isAddition = editLength > 0;
  const possiblyHasRejectedChar =
    isAddition && (lastFormattedValue === formattedValue || formattedValue === placeholder);

  if (possiblyHasRejectedChar) {
    startingSearchIndex = currCaretPos - editLength;
  } else {
    const normalizedStrValue = strValue.toLowerCase();
    const normalizedFormattedValue = formattedValue.toLowerCase();
    const leftHalfChars = [...normalizedStrValue.substr(0, currCaretPos)];
    const intersection = leftHalfChars.filter(
      (char) => normalizedFormattedValue.indexOf(char) !== -1
    );
    const targetChar = intersection[intersection.length - 1];
    const countTargetCharInIntersection = intersection.filter((char) => char === targetChar).length;
    const indexOfPlaceholderChar = formattedValue.indexOf(placeholderChar);
    const countTargetCharInPlaceholder = [
      ...placeholder.substr(
        0,
        indexOfPlaceholderChar > -1 ? indexOfPlaceholderChar : formattedValue.length
      ),
    ].filter((char, index) => char === targetChar && strValue[index] !== char).length;
    const requiredNumberOfMatches = countTargetCharInIntersection + countTargetCharInPlaceholder;

    let numberOfEncounteredMatches = 0;

    [...formattedValue].every((char, index) => {
      startingSearchIndex = index + 1;

      if (char === targetChar) {
        numberOfEncounteredMatches += 1;
      }

      if (numberOfEncounteredMatches >= requiredNumberOfMatches) {
        return false;
      }

      return true;
    });
  }

  const firstPlaceholderChar = [...formattedValue].findIndex((char) => char === placeholderChar);

  if (firstPlaceholderChar !== -1 && firstPlaceholderChar < startingSearchIndex) {
    return firstPlaceholderChar;
  }

  if (isAddition) {
    const lastFormattedStr = lastFormattedValue.substr(currCaretPos - editLength, editLength);
    const formattedStr = formattedValue.substr(currCaretPos - editLength, editLength);
    const rawStr = strValue.substr(currCaretPos - editLength, editLength);

    // formatted value didn't change, set cursor accordingly
    if (lastFormattedValue === formattedValue && lastFormattedStr === formattedStr) {
      return currCaretPos - (rawStr !== formattedStr ? editLength : 0);
    }

    let lastPlaceholderChar = startingSearchIndex;

    for (let i = startingSearchIndex; i <= placeholder.length; i += 1) {
      if (placeholder[i] === placeholderChar) {
        lastPlaceholderChar = i;
      }

      if (
        placeholder[i] === placeholderChar ||
        caretTrapIndexes.includes(i) ||
        i === placeholder.length
      ) {
        // stop the cursor at this exact place if no placeholder chars were found
        if (firstPlaceholderChar === -1) {
          return i;
        }

        return lastPlaceholderChar;
      }
    }
  } else {
    for (let i = startingSearchIndex; i >= 0; i -= 1) {
      if (placeholder[i - 1] === placeholderChar || caretTrapIndexes.includes(i) || i === 0) {
        return i;
      }
    }
  }

  return startingSearchIndex;
}
